








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Unit } from '@/api/com/MetaPattern/APP/MDA/ModelLib/Unit';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { ModelLibService } from '@/api/com/MetaPattern/APP/MDA/ModelLib/ModelLibService';
import { SystemService } from '@/api/com/MetaPattern/APP/MDA/Common/SystemService';
import { UnitBizTypeService } from '@/api/com/MetaPattern/APP/MDA/ModelLib/UnitBizTypeService';
import { UniqueKeyManager } from '@/libs/com/MetaPattern/MDA/MD/UniqueKeyManager';

@Component({
  components: {
  }
})
export default class PublishUnit extends Vue {
  @Prop() transferData: any; // 结构：Json，{app: value; product: value; appId: value; appKey: value}
  @Prop() entity: any;
  private initForm: Unit;
  private bizTypes: Array<any>;

  constructor() {
    super();
    this.initForm = new Unit();
    this.bizTypes = new Array<any>();
    this.getUnit();
  }

  getUnit() {
    let id = '';
    let appId = '';
    let productId = '';
    if (this.transferData) {
      if (this.transferData.app) {
        appId = this.transferData.app.id;
      } else if (this.transferData.product) {
        productId = this.transferData.product.id;
      }
    } else if (this.entity) {
      id = this.entity.id;
    }
    if (id !== '' || appId !== '' || productId !== '') {
      ModelLibService.GetUnitAsync(id, appId, productId)
        .then(res => {
          if (res && res !== null) {
            this.initForm = res;
          } else {
            const unit = new Unit();
            unit.persistenceStatus = EnumPersistenceStatus.Create;
            this.initForm.id = UniqueKeyManager.instance.getUniqueKey();
            if (appId !== '') {
              unit.aPPId = appId;
              unit.name = this.transferData.app.displayName;
            }
            if (productId !== '') {
              unit.name = this.transferData.product.displayName;
              unit.productId = productId;
            }
            this.initForm = unit;
          }
        })
        .catch(err => {
          this.$message({ type: 'error', message: `发布到模型库发生错误：${err}` });
        });
    }
  }

  /** 获取元件类型 */
  getUnitType() {
    if (this.initForm.aPPId !== '') {
      return '应用';
    }
    return '产品';
  }

  /** 获取业务类型 */
  getBizTypes() {
    if (this.bizTypes.length <= 0) {
      const allBizTypes = Array<any>();
      UnitBizTypeService.LoadAllAsync()
        .then(bizTypes => {
          bizTypes.forEach(bizType => {
            if (bizType.parent_ID === null) {
              allBizTypes.push({ label: bizType.name, value: bizType.id, children: [] });
            }
          });
          bizTypes.forEach(bizType => {
            if (bizType.parent_ID !== null) {
              const parent = allBizTypes.find(item => item.value === bizType.parent_ID);
              if (parent) {
                parent.children.push({ label: bizType.name, value: bizType.id, children: null });
              }
            }
          });
          this.bizTypes = allBizTypes;
        });
    }
    return this.bizTypes;
  }

  /** 业务类型选项变更 */
  handleBizTypeChange(value: any) {
    if (value[1]) {
      this.initForm.bizType_ID = value[1];
    }
  }

  /** 提交保存 */
  confirm() {
    (this.$refs.initForm as any).validate((valid: any) => {
      if (valid) {
        const loadingText = '正在努力执行，请耐心等待...';
        const loading = this.$loading({
          lock: true,
          text: loadingText,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        if (this.initForm.persistenceStatus !== EnumPersistenceStatus.Create) {
          this.initForm.persistenceStatus = EnumPersistenceStatus.Update;
        }
        ModelLibService.PublishUnitAsync(this.initForm)
          .then((res: Unit) => {
            this.initForm.persistenceStatus = EnumPersistenceStatus.None;
            this.$message({ type: 'success', message: '发布模型成功!' });
            loading.close();
          })
          .catch(error => {
            this.$message({ type: 'error', message: '保存失败!原因是：' + error });
            loading.close();
          });
      }
      return false;
    });
  }

  cancel() {
    (this.$refs.initForm as any).resetFields();
  }

  /** 定价检查，必须大于等于0的整数 */
  validatePrice(rule: any, value: string, callback: any) {
    const price = Number(value);
    if (isNaN(price) || price < 0) {
      callback(new Error('请输入大于等于0的整数!'));
    }
    callback();
  }

  get labelWidth() {
    return '120px';
  }
}
